import { API } from '@/modules/api-service/api-service';
import type { Core } from '@strapi/types';

export const getDocumentTypes = async () => {
	const { data: response } =
		await API().get<Core.Helpers.Controllers.GetResponseBody<'api::document-type.document-type', 'getDocumentTypes'>>('/document-types');

	return response;
};
